import React, { useState, useEffect } from 'react';
import './AlokaCusstomBlog.css';
import BlogPortal from './pages/BlogPortal/BlogPortal';

const AlokaCusstomBlog = () => {
  return <BlogPortal />;
};

export default AlokaCusstomBlog;
